import { render } from "./ExternalShoppingDetailModal.vue?vue&type=template&id=d1c731c0"
import script from "./ExternalShoppingDetailModal.vue?vue&type=script&lang=js"
export * from "./ExternalShoppingDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__